<template>
  <div class="container-fluid h-100 d-flex justify-content-center align-items-center bg-light">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <div>
            <span class="text-muted large-header">404</span>
            <h4 class="mb-4 text-muted">
              The page you're looking for doesn't exist!
            </h4>
            <div>
              <router-link :to="{ path: '/'}" class="btn btn-primary px-4">
                <icon class="btn-icon" name="home"></icon>
                Go Back Home
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import 'vue-awesome/icons/home'

  export default {
    data() {
      return {}
    }
  }
</script>

<style scoped lang="scss">
  .large-header {
    font-size: 100px;
  }
</style>
